import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Center } from '@core/interfaces/tenant-state';

@Component({
  name: 'bpc-doc-upload-modal',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class DocUploadModal extends Vue {
  $refs: {
    stdUploadDocForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
    };
  };
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'global.upload_doc' }) readonly modalTitle: string;

  public formModel: Center = null;
  public key: number = 0;
  public disableAcceptButton: boolean = true;

  get uploadDocPath() {
    return `${this.$bpcApiRouteHelper.getEntityPath('center')}/doc/upload`;
  }

  close() {
    this.$emit('click-on-close');
  }

  async onUploadDoc() {
    this.disableAcceptButton = true;
    const doc = await this.$refs.stdUploadDocForm.saveEntity();
    await this.$emit('click-on-upload', doc);
    this.disableAcceptButton = false;
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    if (this.formModel?.docs) {
      this.disableAcceptButton = false;
    }
  }
}
